import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input, signal } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import type { MobileQuickAccessItem } from "../mobile-navigation.models";

@Component({
  selector: "mobile-quick-access-fab",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./mobile-quick-access-fab.component.html",
  styleUrl: "./mobile-quick-access-fab.component.scss",
})
export class MobileQuickAccessFabComponent {
  readonly items = input.required<MobileQuickAccessItem[]>();

  protected readonly expanded = signal(false);

  constructor(private readonly router: Router) {}

  protected toggle(): void {
    this.expanded.update((value) => !value);
  }

  protected onAction(item: MobileQuickAccessItem): void {
    this.expanded.set(false);
    void this.router.navigateByUrl(item.Route);
  }
}
